import Papa from 'papaparse'
import yamlLoader from "js-yaml";

export default class ImporterService {
  
  constructor() {
  }
  
  csvHandler(srcPath) {
    return fetch(srcPath).then(
        res => {
          return res.text()
        })
        .then(responseText => {
          return Papa.parse(responseText, {
            header: true,
            skipEmptyLines: true,
          })
        })
        .catch(err => {
          console.log('could not load csv: ', err);
        })
  }
  
  yamlHandler(srcPath) {
    return fetch(srcPath)
        .then((response) => {
          return response.text()
        })
        .then(responseText => {
          return yamlLoader.load(responseText);
        })
        .catch(err => {
          console.log('could not fetch data: ', err);
        })
  }
}
